export enum DeclarationMethod {
    generalContractedSettings = 'generalContractedSettings',
    generalUncontractedSettings = 'generalUncontractedSettings',
    insurerSettings = 'insurerSettings',
    none = 'none',
}
